<template>
    <div class="app-container" style="padding-top: 0">
        <el-form>
            <div style="display:flex">
                <el-form-item label="发货日期" style="display:flex">
                    <el-date-picker
                        v-model="sendForm.date"
                        type="datetime"
                        placeholder="发货日期"
                        format="yyyy-MM-dd HH:mm"
                        value-format="yyyy-MM-dd HH:mm"
                        style="width: 190px"
                    />
                </el-form-item>
                <el-form-item label="生成出库记录" v-if="$common.hasLimits('stockInfo')" style="display:flex;padding-left:10px">
                    <el-switch
                        @change="saveDialogChange"
                        v-model="saveDialog"
                        :active-value="true"
                        :inactive-value="false"
                    />
                </el-form-item>
            </div>
            <div>
                <el-table
                    ref="multipleTable"
                    :data="sendForm.list"
                    tooltip-effect="dark"
                    style="width: 100%; margin-bottom: 20px"
                    :max-height="300"
                    border
                    @cell-click="editCell"
                >
                    <template v-for="(col, index) in cols">
                        <el-table-column
                            v-if="col.show"
                            :key="index"
                            :prop="col.prop"
                            :label="col.label"
                            :width="col.width"
                            :align="col.align"
                            :class-name="col.class"
                        >
                            <template slot-scope="{ row, column }">
                                <template v-if="col.edit">
                                    <template v-if="col.type === 'input'">
                                        <el-input
                                            v-if="row[col.edit]"
                                            ref="editCell"
                                            type="number"
                                            :min="0"
                                            v-model="row[col.prop]"
                                            @click.native.stop="cancelCell(row)"
                                            @blur="cancel(row, column)"
                                            @keyup.enter.native="
                                                cancel(row, column)
                                            "
                                        />
                                        <span v-else>{{ row[col.prop] }}</span>
                                    </template>
                                    <template v-if="col.type === 'select'">
                                        <el-select v-model="row.wid" @change="chaneStock(row,$event)">
                                            <el-option v-for="(item,index) in row.stock" :key="index" :value="item.wid"
                                            :label="item.wname"></el-option>
                                        </el-select>
                                    </template>
                                </template>
                                <template v-else>
                                    <template
                                        v-if="
                                            col.type.substring(
                                                0,
                                                'sum.'.length
                                            ) === 'sum.'
                                        "
                                    >
                                        <el-input
                                            v-model="row[col.prop]"
                                            type="hidden"
                                            :value="sum(row)"
                                            readonly
                                            style="display: none"
                                        />
                                        <span>{{ row[col.prop] }}</span>
                                    </template>
                                    <template v-else-if="col.type === 'image'">
                                        <el-image
                                            v-if="
                                                row[col.prop] &&
                                                row[col.prop].length > 0
                                            "
                                            style="width: 30px"
                                            :src="row[col.prop][0]"
                                            :preview-src-list="row[col.prop]"
                                        />
                                        <div v-else class="errorFonts_mini">
                                            暂无图片
                                        </div>
                                    </template>
                                    <template v-else-if="col.type === 'send'">
                                        <span v-if="row.unit === row[col.prop]"
                                            >已发货</span
                                        >
                                        <span v-else-if="row[col.prop] === 0"
                                            >未发货</span
                                        >
                                        <span v-else
                                            >已发{{ row[col.prop] }}</span
                                        >
                                    </template>
                                    <template v-else-if="col.type === 'stockunit'">
                                        <span :style="row.negative?'':'color:#ff0000'">{{row[col.prop]}}</span>
                                    </template>
                                    <template v-else>
                                        {{ row[col.prop] }}
                                    </template>
                                </template>
                            </template>
                        </el-table-column>
                    </template>
                </el-table>

                <el-form-item label="备注">
                    <el-input type="textarea" v-model="sendForm.remark" />
                </el-form-item>
                <el-form-item style="text-align: center">
                    <el-button type="primary" @click="saveSend">保存</el-button>
                    <el-button @click="closeSend">关闭</el-button>
                </el-form-item>
            </div>
        </el-form>
    </div>
</template>

<script>
export default {
    props: {
        oid: {
            type: Number,
            default: 0,
        },
        odid: {
            type: String,
            default: "",
        },
        cid:{
            type:Number,
            default:0,
        },
    },
    data() {
        return {
            sendForm: {
                list: [],
                oid: "",
                date: this.$common.format(new Date()),
                detail: [],
                remark: "",
                stock: 0,
            },
            saveDialog:this.$common.hasLimits('stockInfo'),
            cols: [
                {
                    prop: "pnumber",
                    label: "商品编号",
                    edit: "",
                    type: "",
                    show: true,
                    width: "",
                },
                {
                    prop: "name",
                    label: "商品名称",
                    edit: "",
                    type: "",
                    show: true,
                    width: "150",
                },
                {
                    prop: "img",
                    label: "图片",
                    edit: "",
                    type: "image",
                    show: true,
                    align: "center",
                    width: 60,
                },
                {
                    prop: "color",
                    label: "颜色",
                    edit: "",
                    type: "",
                    show: true,
                    width: "",
                },
                {
                    prop: "size",
                    label: "尺码",
                    edit: "",
                    type: "",
                    show: true,
                    width: "",
                },
                {
                    prop: "packing",
                    label: "包装单位",
                    edit: "",
                    type: "",
                    show: true,
                    width: "100",
                },
                {
                    prop: "totalNumDesc",
                    label: "总数",
                    edit: "",
                    type: "",
                    show: true,
                    width: 150,
                },
                {
                    prop: "sendedDesc",
                    label: "发货状态",
                    edit: "",
                    type: "send",
                    show: true,
                    width: 120,
                },
                {
                    prop: "stock",
                    label: "仓库",
                    edit: "select",
                    type: "select",
                    show: this.$common.hasLimits('stockInfo'),
                    width: 120,
                },
                {
                    prop: "stockDesc",
                    label: "库存",
                    edit: "",
                    type: "stockunit",
                    show: this.$common.hasLimits('stockInfo'),
                    width: 120,
                },
                {
                    prop: "sendPack",
                    label: "发货数(单位:"+this.$global.pack+")",
                    edit: "packEdit",
                    type: "input",
                    show: this.$global.buyType!=2?true:false,
                    width: 200,
                },
                {
                    prop: "sendSmall",
                    label: "发货数(单位:"+this.$global.unit+")",
                    edit: "smallEdit",
                    type: "input",
                    show: this.$global.buyType!=1?true:false,
                    width: "140",
                },
                {
                    prop: "sendDesc",
                    label: "总发货数",
                    edit: "",
                    type: "sum.sendPack.sendSmall",
                    show: true,
                    width: 160,
                },
            ],
        };
    },
    methods: {
        getList() {
            this.sendForm.oid = this.oid;
            this.$api.getNeedSendOrderDetail({
                oid: this.oid,
                odid: this.odid,
            }).then((res) => {
                this.sendForm.list = res.data.data.map((item) => {
                    item.packing = item.punit +this.$global.unit+ "/" + this.$global.pack;
                    item.img = item.img.map((img) => {
                        return this.$api.baseURL + img;
                    });
                    if(item.stock.length>0){
                        item.negative = item.stock[0].negative;
                        item.wid = item.stock[0].wid;
                        item.wname = item.stock[0].wname;
                        item.stockunit = item.stock[0].unit;
                        item.stockDesc = this.$common.changeSendDesc(item.stockunit?item.stockunit:0,item.punit);
                    }
                    item.sendPack = 0;
                    item.sendSmall = 0;
                    item.send = 0;
                    item.sendedDesc = this.$common.changeSendDesc(item.sended,item.punit);
                    item.totalNumDesc = this.$common.changeSendDesc(item.unit,item.punit);
                    item.sendDesc = this.$common.changeSendDesc(item.send,item.punit);
                    return item;
                });
                this.sendForm.list.map((item) => {
                    var that = this;
                    this.cols.map((col) => {
                        if (col.edit) {
                            that.$set(item, col.edit, false);
                        }
                    });
                    return item;
                });
            });
        },
        cancelCell() {},
        cancel(row, column) {
            setTimeout(() => {
                this.cols.map((col) => {
                    if (col.label === column.label) {
                        row[col.edit] = false;
                    }
                });
            }, 100);
        },
        editCell(row, column) {
            this.cols.map((col) => {
                if (col.label === column.label) {
                    row[col.edit] = !row[col.edit];
                }
            });
            setTimeout(() => {
                this.$nextTick(() => {
                    if (this.$refs.editCell && this.$refs.editCell.length > 0) {
                        this.$refs.editCell[0].focus();
                    }
                });
            }, 200);
        },
        sum(row) {
            row.send =
                parseInt(row.sendPack ? row.sendPack : 0) *
                    parseInt(row.punit ? row.punit : 0) +
                parseInt(row.sendSmall ? row.sendSmall : 0);
            let max = row.unit - row.sended;
            if(this.saveDialog){
                if(row.negative==0&&row.stockunit<max){
                    max = row.stockunit;
                }
            }
            if (row.send > max) {
                row.send = max;
                if(this.$global.buyType==2){
                    row.sendSmall = max;
                }else{
                    row.sendPack = parseInt(max / row.punit);
                    row.sendSmall = parseInt(max % row.punit);
                }
            }
            row.sendDesc = this.$common.changeSendDesc(row.send,row.punit);
        },
        saveSend() {
            this.$confirm("警告", {
                title: "警告",
                message: '请确保发货数量填写正确，总发货数为0的将不会发货',
                showCancelButton: true,
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(
                () => {
                    let obj = {
                        cid:this.cid,
                        contact:'',
                        date:this.sendForm.date,
                        remark:this.sendForm.remark,
                        stock:this.saveDialog?1:0,
                    }
                    let detail = [];
                    this.sendForm.list.forEach(e=>{
                        if(e.send>0){
                            let obj1 = {
                                odid:e.odid,
                                sendUnit:e.send,
                            }
                            if(this.saveDialog){
                                obj1.wid = e.wid;
                            }
                            detail.push(obj1);
                        }
                    })
                    if(detail.length>0){
                        obj.detail = JSON.stringify(detail);
                        this.$api.addOrderSend(obj).then(res=>{
                            if(res.data.code==1){
                                this.$emit("close");
                                this.$notify({
                                    title: "发货",
                                    message: "发货成功",
                                    type: "success",
                                    duration: 1000,
                                });
                            }else{
                                this.$common.error(res.data.msg);
                            }
                        })
                    }else{
                        this.$common.error("没有数据");
                    }
                },
                () => {}
            );
        },
        closeSend() {
            this.$emit("close");
        },
        saveDialogChange(){
            this.cols.forEach(e => {
                if(e.prop=="stock"||e.prop=="stockDesc"){
                    e.show = this.saveDialog;
                }
            });
        },
        chaneStock(data,event){
            for(let i in data.stock){
                if(data.stock[i].wid==event){
                    data.negative = data.stock[i].negative;
                    data.wname = data.stock[i].wname;
                    data.stockunit = data.stock[i].unit;
                    data.stockDesc = this.$common.changeSendDesc(data.stockunit,data.punit);
                    break;
                }
            }
        }
    },
};
</script>